<template>
  <!-- 天气 -->
  <div class="Others7Charts">
    <div class="weather-left" :class="getStyle('title')">
      <div class="w-l-top">
        <!-- 城市 -->
        <div class="cityname flex-t-b">
          <div class="title" :style="getWidthStyle(-4)">
            <span> {{ cityName }}</span>
          </div>
        </div>
        <!-- 天气 -->
        <div class="weather flex-t-b">
          <div class="title" :style="getWidthStyle(-4)">{{ weather }}</div>
          <div class="img">
            <img :src="getImgByWeather(weather)" alt="" />
          </div>
        </div>
        <!-- 温度 -->
        <div class="temperature flex-t-b">
          <div class="title" :style="getWidthStyle(-6)">
            <span>当前温度</span>
            <span style="margin-left: 20px">{{ getNowTime(new Date(), 'normal') }}</span>
          </div>
          <div class="tmp-num" :style="getWidthStyle(80)">{{ temperature }} <span>℃</span></div>
        </div>
      </div>
      <div class="w-l-bottom">
        <div class="border"></div>
        <div class="content">
          <!-- 湿度 -->
          <div class="humidity flex">
            <div class="title" :style="getWidthStyle(-6)">湿度</div>
            <div class="data" :style="getWidthStyle(2)">{{ humidity }}%</div>
          </div>
          <!-- 空气质量 -->
          <div class="air flex">
            <div class="title" :style="getWidthStyle(-6)">空气质量</div>
            <!-- <div class="data" :style="getWidthStyle(2)" v-if="api"> -->
            <div class="data" :style="getWidthStyle(2)">
              <!-- <span>{{ aqi }}</span> <span>({{ aqiName }})</span> -->
              <span>{{ aqiName ? aqiName : ' 良好' }}</span>
            </div>
            <!-- <div class="data" :style="getWidthStyle(2)" v-else><span></span><span>暂无数据</span></div> -->
          </div>
          <!-- 风力风向 -->
          <div class="wind flex">
            <div class="title" :style="getWidthStyle(-6)">{{ winddirection }}</div>
            <div class="data" :style="getWidthStyle(2)">{{ windpower }}级</div>
          </div>
          <!-- PM2.5指数 -->
          <!-- <div class="pm25 flex">
            <div class="title" :style="getWidthStyle(-6)">PM2.5指数</div>
            <div class="data" :style="getWidthStyle(2)">{{ pm2point5 }}</div>
          </div> -->
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="weather-right">
      <div class="seven-forecast" v-for="(item, index) in forecasts" :key="index">
        <div class="s-f-left">
          <div class="date">
            <div class="d-top" :style="getWidthStyle(-6)">{{ getNowTime(item.date, 'special')[0] }}</div>
            <div class="d-bottom" :style="getWidthStyle(-8)">{{ getNowTime(item.date, 'special')[1] }}</div>
          </div>
          <div class="weather-img">
            <img :src="getImgByWeather(item.weather)" alt="" style="width: 40px" />
          </div>
        </div>
        <div class="s-f-right">
          <div class="weather-name" :style="getWidthStyle(-6)">{{ item.weather }}</div>
          <div class="tmp-max-min" :style="getWidthStyle(-8)">
            <span>{{ item.maxTmp }}℃</span>
            ~
            <span>{{ item.minTmp }}℃</span>
          </div>
        </div>
        <!-- <div class="bg-img">
          <img src="../../../assets/img/weather_bg.png" alt="" />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { request } from '../../../common/request';
export default {
  name: 'Others7Charts',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 72,
      },
      timeString: '',
      dateString: '',
      cityName: '',
      city: '',
      weather: '', // 当前天气
      temperature: '', // 当前温度
      humidity: '', // 湿度
      winddirection: '', // 风向
      windpower: '', // 风力
      aqi: 0, // 空气质量数值
      aqiName: '', // 控制质量描述
      pm2point5: '0', // PM2.5
      forecasts: [
        {
          weather: '多云',
          date: '2023-05-16',
          maxTmp: '30',
          minTmp: '21',
        },
        {
          weather: '阴',
          date: '2023-05-17',
          maxTmp: '33',
          minTmp: '23',
        },
        {
          text: '多云',
          date: '2023-05-18',
          high: '31',
          minTmp: '24',
        },
        {
          weather: '阵雨',
          date: '2023-05-19',
          maxTmp: '30',
          minTmp: '21',
        },
        {
          weather: '阵雨',
          date: '2023-05-20',
          maxTmp: '18',
          minTmp: '19',
        },
      ], // 未来的天气预报
      province: '',
      toggleBoolean: true,
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      headerLon: '',
      headerLat: '',
      params: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerLon = val.propertyData.headerLngLatData.value.lon;
        this.headerLat = val.propertyData.headerLngLatData.value.lat;
      },
    },
    cityNameCopy(nV, oV) {
      if (nV) {
        this.onConfigurationChange();
      }
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        case 'V9Style':
          style['V9' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    // 获取时间
    getNowTime(time, flag) {
      let now = new Date(time);
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      let day = now.getDay(); // 得到周几
      month = month + 1;
      month = month.toString().padStart(2, '0');
      date = date.toString().padStart(2, '0');

      function getWeek(index, specialDeal = false) {
        let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        let result = '';
        if (specialDeal) {
          let currentDate = new Date().getDate().toString().padStart(2, '0');
          let tomorrow = new Date();
          tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
          let tomorrowDate = tomorrow.getDate().toString().padStart(2, '0');
          result = week[index];
          if (currentDate == date) {
            result = '今天';
          }
          if (tomorrowDate == date) {
            result = '明天';
          }
        } else {
          result = week[index];
        }
        return result;
      }

      if (flag == 'normal') {
        return `${getWeek(day)} ${year}-${month}-${date}`;
      }
      if (flag == 'special') {
        return [`${getWeek(day, true)}`, `${month}-${date}`];
      }
    },
    // 通过天气判断显示的图片并返回路径
    getImgByWeather(weather) {
      let img = '';
      if (weather == '晴') img = 'icon_weatherType1';
      else if (weather == '多云') img = 'icon_weatherType2';
      else if (weather == '小雨' || weather == '中雨' || weather == '阵雨') img = 'icon_weatherType3';
      else if (weather == '暴雨' || weather == '大雨') img = 'icon_weatherType4';
      else if (weather == '阴') img = 'icon_weatherType5';
      else if (weather == '小雪' || weather == '中雪') img = 'icon_weatherType6';
      else if (weather == '大雪' || weather == '暴雪') img = 'icon_weatherType7';
      else img = 'icon_weatherType1';
      return `./img/weather/${img}.png`;
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      this.cityName = this.Configuration.propertyData.cityName.value;

      this.getWeather();
    },
    getWeather() {
      // 该接口获取当天基础数据
      let url = `https://restapi.amap.com/v3/weather/weatherInfo?city=${this.cityName}&output=json&key=db5d2728c584e5884c385c2a509b29b9`;
      // 该链接获取近七日天气
      // let url1 = `https://free-api.heweather.net/s6/weather/forecast?location=${this.cityName}&key=a038e183208c4aed999f9de1799005c2`;
      // 该链接获取空气指数
      let url2 = '';
      // let params = {
      //   method: 'get',
      //   url: url,
      //   dataType: 'jsonp',
      // };
      this.$axios({
        method: 'get',
        url: url,
        dataType: 'jsonp',
      })
        // request(params)
        .then(res => {
          if (res.status === 200) {
            if (!(res.data.lives[0] instanceof Array)) {
              let { humidity, temperature, weather, city, province, winddirection, windpower } =
                res.data.lives[0];
              this.weather = weather; // 当前天气
              this.temperature = temperature; // 当前温度
              this.humidity = humidity; // 湿度
              this.winddirection = winddirection; // 风向
              this.windpower = windpower; // 风力
              this.city = city; // 城市
              // let province = province; // 省份
              if ((this.headerLon, this.headerLat)) {
                let LonLat = this.headerLon + ',' + this.headerLat;
                LonLat = LonLat.replace(/\s*/g, ''); // 去除字符串里的空格
                return new Promise((resolve, reject) => {
                  this.axios({
                    method: 'get',
                    // 该接口为和风天气插件 生成接口
                    url: `https://devapi.qweather.com/v7/air/5d?location=${LonLat}&key=972802b2c6ea46a6bd275fa504584b5f`,
                    // dataType: 'jsonp',
                    xhrFields: { withCredentials: true },
                    crossDomain: true,
                  }).then(res => {
                    resolve(res);
                  });
                });
              }
            }
          }
        })
        .then(res => {
          if (res.data.code === '200') {
            this.aqiName = res.data.daily[0].category;
          }
        });

      let allurl = `https://restapi.amap.com/v3/weather/weatherInfo?city=${this.cityName}&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all`;
      // 请求近七天的天气数据
      let weather = [];
      this.$axios({
        method: 'get',
        url: allurl,
        params: { district_id: 441823 },
        // dataType: 'jsonp'
      }).then(res => {
        if (res.status === 200) {
          let alldata = res.data.forecasts[0];
          alldata.casts.forEach(item => {
            weather.push({
              date: item.date,
              weather: item.dayweather,
              maxTmp: item.daytemp_float,
              minTmp: item.nighttemp_float,
            });
          });

          this.forecasts = weather;
        }
      });
    },
    getHeaderInfopStyle(fs = 14, pt = 0) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getWidthStyle(fs = 14) {
      return {
        fontSize: this.$w_Ratio(fs + this.getShowfontSizeBase(), this.$store) + 'px',
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let source = [];
      let WeatherData = [];
      let seriesList = [];
      let WeatherTheDay = [];

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        WeatherTheDay = ParamData?.WeatherTheDay; // 当天天气
      }

      source.forEach(item => {
        WeatherData.push({
          date: item.date, // 时间
          weather: item.weather, // 天气
          maxTmp: item.maxTmp, // 最高温度
          minTmp: item.minTmp, // 最低温度
        });
      });

      this.forecasts = WeatherData;
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();

          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          this.axios({
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          })
            // let param = {
            //   method: ChartsData.apiData.apiUrlMethod,
            //   url: ChartsData.apiData.apiUrl,
            //   params: this.params,
            //   headers: header,
            // };

            // request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
    }),
    cityNameCopy() {
      return this.Configuration.propertyData.cityName.value;
    },
  },
  Configuration: {
    componentTitle: '天气',
    componentName: 'Others7Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others7Charts.png',
    id: '',
    style: {
      width: 810,
      height: 440,
      left: 0,
      top: 0,
    },
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(0, 0, 0, 0.6)',
        lable: '头部背景颜色',
      },
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },

      //       ChartsData: {
      //         lable: '数据接入',
      //         propertyComponentName: 'ChartsDataConfigor',
      //         value: {
      //           currenEntry: 'staticData',
      //           apiData: {
      //             apiUrl:
      //               'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
      //             // apiUrl:
      //             // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%22202one-0three-01%22,%22date_end%22:%22202one-0three-31%22%7D&directory_code=pro_ownerstatistics&type=day',
      //             apiResponseQuery: 'data.forecasts',
      //             isUseFilter: true,
      //             apiFilter: `
      //           // 可以使用data访问api请求的响应结果
      // let seriesList = []

      // let seriesListKey = 'city'
      // let seriesListChildrenKey = 'casts'

      // data.forEach((item) => {
      //   seriesList.push(item[seriesListKey])
      // })
      // dataSet.seriesList = seriesList
      // dataSet.source = []
      // data.forEach((item) => {
      //   item[seriesListChildrenKey].forEach(item2 => {
      //     dataSet.source.push({
      //       s: item[seriesListKey],
      //       x: item2.date,
      //       y: item2.daytemp
      //     })
      //   })
      // })
      //           `,
      //             apiUrlMethod: 'get',
      //             isUseInterval: true,
      //             apiInterval: 10,
      //             apiUrlMethod: 'get',
      //             apiPostParams: '',
      //             isUseUserKey: true, // 是否使用user_key
      //           },
      //           staticData: {
      //             seriesList: ['杭州'],
      //             source: [
      //               {
      //                 weather: '多云',
      //                 date: '2023-05-16',
      //                 maxTmp: '30',
      //                 minTmp: '21',
      //               },
      //               {
      //                 weather: '阴',
      //                 date: '2023-05-17',
      //                 maxTmp: '33',
      //                 minTmp: '23',
      //               },
      //               {
      //                 text: '多云',
      //                 date: '2023-05-18',
      //                 high: '31',
      //                 minTmp: '24',
      //               },
      //               {
      //                 weather: '阵雨',
      //                 date: '2023-05-19',
      //                 maxTmp: '30',
      //                 minTmp: '21',
      //               },
      //               {
      //                 weather: '阵雨',
      //                 date: '2023-05-20',
      //                 maxTmp: '18',
      //                 minTmp: '19',
      //               },
      //             ],
      //           },
      //         },
      //       },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      showStatus: {
        value: 'norm',
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.Others7Charts {
  width: 100%;
  height: 100%;
  color: #7eb3e5;
  display: flex;
  padding: 10px 0 10px 0;

  .weather-left {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .w-l-top {
      height: 60%;
      display: flex;
      justify-content: space-around;

      .weather {
        .img {
          // margin-top: 40px;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      .temperature {
        text-align: left;

        .tmp-num {
          height: 100%;
          // margin-top: 40px;
          font-size: 60px;
          color: #00f4fd;
          width: 100%;
          display: flex;
          align-items: center;

          span {
            font-size: 40px;
          }
        }
      }

      div {
        // margin-left: 20px;
      }
      .cityname {
        color: #00f4fd;
      }
      .flex-t-b {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
      }
    }

    .w-l-bottom {
      height: 40%;

      .border {
        width: 100%;
        height: 3px;
        background: radial-gradient(circle, #214569, transparent);
      }

      .content {
        padding: 0 20px;
        height: 100%;
        display: flex;
        justify-content: space-around;

        // border-top: 4px solid #000;
        // border-bottom: 4px solid #000;
        .air {
          .data {
            span {
              &:nth-child(2) {
                font-size: 12px;
              }
            }
          }
        }

        .flex {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .data {
            color: #fff;
            margin-top: 8px;
          }
        }
      }

      // border-image: radial-gradient(circle,#214569 80%, transparent 20%);
    }
  }

  .weather-right {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .seven-forecast {
      width: 100%;
      height: 15%;
      min-height: 50px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      position: relative;
      padding: 10px 0;
      background: url('../../../assets/img/weather_bg.png') no-repeat;
      background-size: 100% 100%;

      // min-height: 84px;
      // background: linear-gradient(30deg,#a6adb2,#010407);
      // margin-top: 10px;
      &:nth-child(1) {
        // margin-top: 0;
      }

      .bg-img {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;

        img {
          // width: 100%;
          // height: 100%;
        }
      }

      .s-f-left {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 2;

        // margin: 10px 0;
        .date {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;

          .d-top {
            margin-bottom: 8px;
          }

          .d-bottom {
            font-size: 12px;
          }
        }

        .weather-img {
          margin-left: 20px;
        }
      }

      .s-f-right {
        width: 50%;
        display: flex;
        flex-direction: column;
        // text-align: center;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 2;

        // margin: 10px 0;
        .tmp-max-min {
          font-size: 12px;
          margin-top: 8px;
        }
      }
    }
  }
}

.title {
  font-size: 14px;
}

.V8Style {
  .weather-left {
    color: #000 !important;
  }

  .seven-forecast {
    color: #000 !important;
  }

  .data {
    color: #000 !important;
  }
}

.v2-style {
  z-index: 99;
  // position: absolute;
  // top: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  // transform: scale(0.3);
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.39) 45%, transparent 100%);

  // background-color: rgb(14, 33, 73);
  .header-left {
    max-width: 460px;
    width: 30%;
    height: 100%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }

  .header-middle {
    .header-middle-filter {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 85%;

      background: -moz-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: -o-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: -ms-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
    }

    width: 30.5%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    flex-shrink: 1;
    overflow: hidden;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      color: transparent;

      background-image: -moz-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: -o-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: -ms-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);

      -webkit-background-clip: text;
      -webkit-text-stroke: 0.5px rgb(0, 0, 0);
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;

      p {
        margin: 0;
      }
    }

    .spotlight-ct {
      position: absolute;
      bottom: -5%;
      left: 50%;
      transform: translateX(-49.5%);
      width: 70%;
      height: 30%;
      overflow: hidden;

      // background-color: rgba(204, 204, 204, 0.308);
      .spotLight1 {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #00eee2 12%,
          #befdff 12%,
          #00eee2 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 4s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #00eee2 9%,
          rgb(198, 255, 252) 9%,
          rgb(0, 238, 226) 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );

        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 4s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      @keyframes titlelight {
        0% {
          left: -40%;
          opacity: 1;
          transform: scale(1.2, 1.3) translate(-50%, -50%);
        }

        35% {
          opacity: 0.7;
          transform: scale(1.6, 1.5) translate(-50%, -50%);
        }

        50% {
          opacity: 1;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        75% {
          opacity: 0.5;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        100% {
          left: 120%;
          opacity: 1;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }

  .header-right {
    max-width: 520px;
    width: 40%;
    height: 100%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item0 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 100%;
        color: #95ccff;
      }

      .info-item1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30%;
        height: 100%;
        color: #95ccff;
      }

      .info-item2 {
        display: flex;
        //align-items: center;
        justify-content: center;
        align-self: center;
        width: 30%;
        height: 80%;

        .info-item2-wrapper {
          width: 100%;
          height: 80%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .info-item2-hour {
          margin-left: 60%;
          display: flex;
          height: 34%;
          width: 60%;

          div {
            height: 100%;
            width: 8%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        .info-item2-date {
          margin-top: 3%;
          margin-left: 33%;
          display: flex;
          height: 20%;
          width: 70%;

          div {
            height: 100%;
            width: 8%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        p {
          margin: 0;
          padding: 0;
        }
      }

      .info-item3 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 100%;
      }
    }
  }
}
</style>
